let timer = null;

// eslint-disable-next-line import/prefer-default-export
export const delayOnKeyup = (payload) => {
  if (timer) {
    clearTimeout(timer);
    timer = null;
  }
  timer = setTimeout(() => {
    payload();
  }, 2000);
};

export const formatArray = (arr, formatter = '') => arr.join(formatter);

export const hmsToSeconds = (str) => {
  const p = str.split(':');
  let s = 0; let
    m = 1;

  while (p.length > 0) {
    s += m * parseInt(p.pop(), 10);
    m *= 60;
  }

  return s;
};

export const secondsToMinutes = (seconds) => Math.floor(seconds / 60);

export const addTimeToDate = (date, minutes) => new Date(new Date(date).getTime() + minutes * 60000);

export const countDownToDate = (from, to, d) => {
  const diff = d || to.getTime() - from.getTime();

  // console.log('countDownToDate');
  // console.log('from', from);
  // console.log('to', to);
  // console.log('d', d);

  const days = Math.floor(diff / (1000 * 60 * 60 * 24));
  const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
  const seconds = Math.floor((diff % (1000 * 60)) / 1000);

  if (diff < 0) {
    return false;
  }

  return {
    days: days < 10 ? `0${days}` : days,
    hours: hours < 10 ? `0${hours}` : hours,
    minutes: minutes < 10 ? `0${minutes}` : minutes,
    seconds: seconds < 10 ? `0${seconds}` : seconds,
  };
};

export const certificateDate = (date) => new Date(date).toLocaleDateString('en-GB', { day: '2-digit', month: 'long', year: 'numeric' });

export const toUrl = (url) => new URL(url);

export const validUrl = (u) => {
  try {
    const url = toUrl(u);
    return ['http:', 'https:'].includes(url.protocol);
  } catch (e) {
    return false;
  }
};

export const calculateBilledPerMonth = (currentPlan, allPlans, sale) => {
  const {
    id,
    discountPrice = 0,
    source,
  } = currentPlan;

  let { price } = currentPlan;

  let finalPrice = !sale && !source ? price : (discountPrice || price);

  const isCurrent = id === allPlans.active.plan.id;

  const showCurrentBilling = currentPlan.discountPrice >= allPlans.active.nextChargePrice && isCurrent;

  if (showCurrentBilling) {
    finalPrice = allPlans.active.nextChargePrice;
    price = allPlans.active.nextChargePrice;
  }

  let billedPerMonth = 0;
  let billedPerMonthDiscount = 0;
  let billedPerMonthDiscountPercent;
  if (id === allPlans.monthly.id) {
    billedPerMonth = price;
    billedPerMonthDiscount = finalPrice;
    billedPerMonthDiscountPercent = Math.floor((1 - (finalPrice / price)) * 100);
  } else if (id === allPlans.quarterly.id) {
    billedPerMonth = price / 3;
    billedPerMonthDiscount = finalPrice / 3;
    const { monthly } = allPlans;
    const monthlyPrice = monthly.price * 3;
    billedPerMonthDiscountPercent = Math.floor((1 - (finalPrice / monthlyPrice)) * 100);
  } else if (id === allPlans.annual.id) {
    billedPerMonth = price / 12;
    billedPerMonthDiscount = finalPrice / 12;
    const { monthly } = allPlans;
    const monthlyPrice = monthly.price * 12;
    billedPerMonthDiscountPercent = Math.round((1 - (finalPrice / monthlyPrice)) * 100);
  }

  billedPerMonthDiscountPercent = billedPerMonthDiscountPercent === 19 ? 20 : billedPerMonthDiscountPercent;

  if (showCurrentBilling) {
    billedPerMonthDiscountPercent = 0;
  }

  return {
    regular: Number.isInteger(billedPerMonth) ? billedPerMonth : billedPerMonth.toFixed(2),
    discount: Number.isInteger(billedPerMonthDiscount) ? billedPerMonthDiscount : billedPerMonthDiscount.toFixed(2),
    save: billedPerMonthDiscountPercent ? `Save ${billedPerMonthDiscountPercent}%` : null,
    get: billedPerMonthDiscountPercent ? `Get ${billedPerMonthDiscountPercent}% Off` : null,
  };
};

export const calculateSubscriptionsLeft = (currentDate, {
  startDate, endDate, subscriptions, numbers, pos,
}) => {
  // CAMPAIGN SWITCH: do not remove this comment
  const isSeconds = false;

  let result = 0;
  let position = pos;
  let nowDate = currentDate;
  const promoStartDate = new Date(startDate);
  if (nowDate > endDate) { // fallback to last date
    nowDate = endDate;
  }

  let startMinutes = promoStartDate.getMinutes();
  let totalMinutes = (nowDate - promoStartDate) / 1000 / 60;

  if (isSeconds) {
    startMinutes = promoStartDate.getSeconds();
    totalMinutes = (nowDate - promoStartDate) / 1000;
  }
  const minutes = totalMinutes % 60;
  const hours = Math.floor(totalMinutes / 60);
  let currentHourIterationsPassed = 0;
  if (startMinutes > 0) {
    if (minutes >= 45) {
      currentHourIterationsPassed = 3;
    } else if (minutes >= 30) {
      currentHourIterationsPassed = 2;
    } else if (minutes >= 0) {
      currentHourIterationsPassed = 1;
    }
  } else if (minutes >= 30) {
    currentHourIterationsPassed = 3;
  } else if (minutes >= 15) {
    currentHourIterationsPassed = 2;
  } else if (minutes >= 0) {
    currentHourIterationsPassed = 1;
  }
  const iterations = hours * 3 + currentHourIterationsPassed;
  let totalNumbers = 0;
  if (iterations > 0) {
    for (let i = 0; i < iterations; i += 1) {
      totalNumbers += numbers[position];
      if (position >= numbers.length - 1) {
        position = 0;
      } else {
        position += 1;
      }
    }
  }
  result = subscriptions - totalNumbers;
  if (result > 200) {
    result = 200;
  } else if (result < 0 || Number.isNaN(result)) {
    result = 0;
  }

  return result;
};

export const getPromotion = (promotions, currentPromotion, platform) => {
  let runningPromotion = promotions.find((p) => new Date() < new Date(p.endDate)) || {};
  const lastPromotion = promotions[promotions.length - 1];
  let runningPromotionCoupon = null;
  let currentPromotionCoupon = null;

  function getCoupon(runningPromo, currentPromo) {
    let runningPromoCoupon = null;
    let currentPromoCoupon = null;

    if (platform === 'fa') {
      runningPromoCoupon = runningPromo?.couponFA || runningPromo?.coupon;
      currentPromoCoupon = currentPromo?.couponFA || currentPromo?.coupon;
    } else {
      runningPromoCoupon = runningPromo?.coupon;
      currentPromoCoupon = currentPromo?.coupon;
    }

    return [runningPromoCoupon, currentPromoCoupon];
  }

  [runningPromotionCoupon, currentPromotionCoupon] = getCoupon(runningPromotion, currentPromotion);

  // set last promotion if runningPromotion is empty
  if (!runningPromotionCoupon) {
    runningPromotion = lastPromotion;

    [runningPromotionCoupon, currentPromotionCoupon] = getCoupon(runningPromotion, currentPromotion);
  }

  // set flag for fetching prices again / refreshing the page
  const refresh = (currentPromotion && currentPromotionCoupon && currentPromotionCoupon !== runningPromotionCoupon)
    || (currentPromotion && new Date() >= new Date(currentPromotion.endDate));

  // return latest date in promotion - countdown
  return {
    nextPromotion: {
      ...runningPromotion,
      coupon: runningPromotionCoupon,
    },
    lastEndDate: new Date(lastPromotion.endDate),
    refresh,
  };
};

export const dateInRightInterval = (date) => {
  // CAMPAIGN SWITCH: do not remove this comment
  const intervals = [0];
  // const intervals = [15, 30, 0];
  // can be switched to seconds for testing
  // return intervals.includes(date.getSeconds());
  return intervals.includes(date.getMinutes()) && date.getSeconds() === 0;
};

export const striptags = (html, allowedTags) => {
  let tagsToKeep = allowedTags.trim();

  if (tagsToKeep) {
    tagsToKeep = tagsToKeep.split(/\s+/).map((tag) => `/?${tag}`);
    tagsToKeep = `(?!${tagsToKeep.join('|')})`;
  }

  if (!html) {
    return '';
  }

  return html.replace(new RegExp(`(<${tagsToKeep}.*?>)`, 'gi'), '');
};

export const loadHotJar = () => {
  let id;
  const hotJarIds = {
    ds: {
      site: 1214727,
      lms: 4939467,
    },
    fa: {
      site: 2256542,
      lms: 5093414,
    },
  };

  if (window.$nuxt.$config) {
    const { platform, project } = window.$nuxt.$config;

    if (hotJarIds[platform][project]) {
      id = hotJarIds[platform][project];
    }
  }

  if (!id) {
    return;
  }

  /* eslint-disable no-param-reassign */
  /* eslint-disable no-underscore-dangle */
  /* eslint-disable func-names */
  function hotJar(h, o, t, j, a, r) {
    // eslint-disable-next-line prefer-rest-params
    h.hj = h.hj || function () { (h.hj.q = h.hj.q || []).push(arguments); };
    h._hjSettings = { hjid: id, hjsv: 6 };
    // eslint-disable-next-line prefer-destructuring
    a = o.getElementsByTagName('head')[0];
    r = o.createElement('script'); r.async = 1;
    r.src = t + h._hjSettings.hjid + j + h._hjSettings.hjsv;
    a.appendChild(r);
  }

  hotJar(window, document, 'https://static.hotjar.com/c/hotjar-', '.js?sv=');
};

export const blockEditorSumWords = (rootObj) => {
  let totalSum = 0;

  const recursiveSum = (currentObj) => {
    // eslint-disable-next-line no-restricted-syntax, guard-for-in
    for (const key in currentObj) {
      if (typeof currentObj[key] === 'object') {
        recursiveSum(currentObj[key]);
      } else if (key === 'words') {
        totalSum += currentObj[key];
      }
    }
  };

  recursiveSum(rootObj);
  return totalSum;
};
